<div
  class="d-flex flex-column align-items-center h-100 px-plus"
  [formGroup]="form"
>
  <div class="d-flex flex-column align-items-center justify-content-center mt-giant">
    <span class="text-onback-high t-5 mb-tiny">ثبت کد ملی</span>
    <span class="text-onback-low b-1 mb-big text-align-center"
      >برای حفظ امنیت حساب کاربری و بازیابی آسان رمز عبور، کد ملی خود را وارد کنید.</span
    >
    <div class="w-100">
      <ui-form-field
        [error]="form.controls['nationalCode'].errors"
        [disabled]="form.controls['nationalCode'].disabled"
        [formControlName]="'nationalCode'"
        [label]="'کد ملی'"
        [inputType]="'text'"
        [isNumericKeyboard]="true"
        [maxSize]="10"
        [convertNonEnglishDigits]="true"
        [errorMessageMapper]="{
          invalidNotionalCode: 'کد ملی واردشده نامعتبر است.',
          serverError: 'کد ملی وارد شده با شماره موبایل تطابق ندارد',
        }"
        [hint]="'کد ملی باید ۱۰ رقم باشد برای مثال: ۰۰۱۲۳۴۵۶۷۸'"
        [hasHintStar]="true"
        [type]="'input'"
        [hasCleaner]="true"
        [showError]="showError()"
      ></ui-form-field>
    </div>
  </div>

  <div
    class="d-flex w-100 gap-small mb-plus mt-giant"
    [style.bottom]="'20px'"
  >
    @if (cancelable()) {
      <ngx-button
        [size]="'large'"
        [style]="'tinted-on-elevated'"
        (clickHandler)="handleCancelClick()"
      >
        انصراف
      </ngx-button>
    }

    <ngx-button
      [mode]="'form'"
      [size]="'large'"
      [style]="'fill'"
      (clickHandler)="submitForm()"
      [disabled]="form.invalid || isLoading()"
      [isLoading]="isLoading()"
      [fullWidth]="true"
      [leftIcon]="{ name: 'arrow-left', type: 'linear' }"
    >
      تایید و ادامه
    </ngx-button>
  </div>

  @if (isCanceling()) {
    <common-shahkar-cancel-shahkar-dialog
      (cancelClicked)="handleCancelClick()"
      (confirmClicked)="handleDeletePin()"
    ></common-shahkar-cancel-shahkar-dialog>
  }
</div>
